module.exports = __webpack_public_path__ + "db20ecf7303c07f62481a505052b547d.png";